import { FileSaver } from '../http/file-saver.ts';
import { Provide } from '../ioc-container/ioc-container.ts';
import { saveAs } from 'file-saver';

@Provide(FileSaver)
export class FileSaverWrapper implements FileSaver {
	save(data: Blob, fileName: string): void {
		saveAs(data, fileName);
	}
}
